import { signOut } from '@backoffice-frontend/authentication'
import { LOGIN_INTENDED_PATH } from '@backoffice-frontend/common'
import { ActionItem } from '@moia-dev/pace-web'
import { useTranslation } from 'react-i18next'
import store from 'store'

export const LogoutButton = () => {
  const { t } = useTranslation()

  const logout = async () => {
    store.remove(LOGIN_INTENDED_PATH)
    await signOut()
  }

  return <ActionItem label={t('common_logout_button')} onClick={logout} />
}
